export default [{name:'天猫',url:'https://list.tmall.com/search_product.htm?q='},{name:'淘宝',url:'https://s.taobao.com/search?q='},{name:'京东',url:'https://search.jd.com/Search?keyword='},{name:'值得买',url:'https://search.smzdm.com/?c=home&s='},{name:'亚马逊',url:'https://www.amazon.cn/s/ref=nb_sb_noss?field-keywords='},{name:'网易严选',url:'https://you.163.com/search?keyword='},{name:'阿里巴巴',url:'https://s.1688.com/selloffer/offer_search.htm?keywords='},{name:'阿里联盟',url:'https://pub.alimama.com/portal/v2/pages/promo/goods/index.htm?pageNum=1&sort=&q='}];


//////////////////
// WEBPACK FOOTER
// ./src/assets/yaml/searchShop.yaml
// module id = null
// module chunks = 